import { c as _c } from "react/compiler-runtime";
const Step = t0 => {
    const $ = _c(26);
    let children;
    let isActive;
    let isDone;
    let noArrow;
    let number;
    let onClick;
    let props;
    let t1;
    if ($[0] !== t0) {
        ({
            number,
            children,
            noArrow,
            isActive,
            isDone,
            className: t1,
            onClick,
            ...props
        } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = isActive;
        $[3] = isDone;
        $[4] = noArrow;
        $[5] = number;
        $[6] = onClick;
        $[7] = props;
        $[8] = t1;
    }
    else {
        children = $[1];
        isActive = $[2];
        isDone = $[3];
        noArrow = $[4];
        number = $[5];
        onClick = $[6];
        props = $[7];
        t1 = $[8];
    }
    const className = t1 === undefined ? "" : t1;
    const isDisabled = !onClick;
    const computedClassName = `relative flex flex-row items-center p-2 w-full h-full font-semibold text-xs justify-center sm:text-sm md:text-base md:p-4 ${isDisabled || isActive ? "cursor-default" : ""} ${isDone ? "bg-gray-500 text-white" : isActive ? "bg-primary text-white" : "bg-gray-200 text-gray-500"} ${!isDisabled && !isActive ? "group-hover:bg-primary group-hover:text-white" : ""} ${className}`;
    const numberClassName = `flex flex-shrink-0 justify-center items-center rounded-full mr-1 w-4 h-4 xxs:mr-2 sm:w-4 sm:h-4 md:w-6 md:h-6 border ${isDone ? "border-white bg-white text-gray-500" : isActive ? "border-white bg-white text-primary" : "border-gray-500 text-gray-500"} ${!isDisabled && !isActive ? "group-hover:bg-white group-hover:border-white group-hover:text-primary" : ""}`;
    const arrowClassName = noArrow ? "" : `hidden sm:block absolute z-[1] right-[-15px] h-[110%] tunnel-stepper-arrow ${isDone ? "tunnel-stepper-arrow-done" : isActive ? "tunnel-stepper-arrow-active" : ""} ${!isDisabled && !isActive ? "tunnel-stepper-arrow-clickable" : ""}`;
    const ariaCurrent = isActive ? "step" : false;
    let t2;
    if ($[9] !== number || $[10] !== numberClassName) {
        t2 = <span className={numberClassName}>{number}</span>;
        $[9] = number;
        $[10] = numberClassName;
        $[11] = t2;
    }
    else {
        t2 = $[11];
    }
    let t3;
    if ($[12] !== children) {
        t3 = <span className="truncate">{children}</span>;
        $[12] = children;
        $[13] = t3;
    }
    else {
        t3 = $[13];
    }
    let t4;
    if ($[14] !== arrowClassName || $[15] !== noArrow) {
        t4 = !noArrow && <><div className="hidden sm:block absolute z-[1] right-[-17px] h-[110%] tunnel-stepper-arrow tunnel-stepper-arrow-white"/><div className={arrowClassName}/></>;
        $[14] = arrowClassName;
        $[15] = noArrow;
        $[16] = t4;
    }
    else {
        t4 = $[16];
    }
    let t5;
    if ($[17] !== ariaCurrent || $[18] !== computedClassName || $[19] !== isDisabled || $[20] !== onClick || $[21] !== props || $[22] !== t2 || $[23] !== t3 || $[24] !== t4) {
        t5 = <div className="group w-1/3"><button className={computedClassName} type="button" disabled={isDisabled} aria-disabled={isDisabled} aria-current={ariaCurrent} onClick={onClick} {...props}>{t2}{t3}{t4}</button></div>;
        $[17] = ariaCurrent;
        $[18] = computedClassName;
        $[19] = isDisabled;
        $[20] = onClick;
        $[21] = props;
        $[22] = t2;
        $[23] = t3;
        $[24] = t4;
        $[25] = t5;
    }
    else {
        t5 = $[25];
    }
    return t5;
};
export default Step;
